import React, { type FC, useMemo } from "react";
import { AppRoutes } from "@domain/routing/routeConstants";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router-dom";
import { ModuleNav, type NavItem } from "./ModuleNav";

export const ModuleCommonKontoControlLinks: FC = () => {
    const { pathname = "" } = useLocation();
    const selectedKeys = useMemo(() => [pathname], [pathname]);
    const items = useMemo<NavItem[]>(
        () => [
            {
                key: AppRoutes.manageAccountCategories,
                to: AppRoutes.manageAccountCategories,
                label: <FormattedMessage id="app.titles.category.pl" tagName="span" />,
            },
            {
                key: AppRoutes.manageAccountCreditors,
                to: AppRoutes.manageAccountCreditors,
                label: <FormattedMessage id="app.titles.creditor.pl" tagName="span" />,
            },
            {
                key: AppRoutes.manageAccountDebitor,
                to: AppRoutes.manageAccountDebitor,
                label: <FormattedMessage id="app.titles.debitor.pl" tagName="span" />,
            },
            {
                key: AppRoutes.manageAccountTag,
                to: AppRoutes.manageAccountTag,
                label: <FormattedMessage id="app.titles.tag.pl" tagName="span" />,
            },
            {
                key: AppRoutes.manageAccountRecordText1Templates,
                to: AppRoutes.manageAccountRecordText1Templates,
                label: <FormattedMessage id="app.fields.buchtext" tagName="span" />,
            },
            {
                key: AppRoutes.manageAccountRecordText2Templates,
                to: AppRoutes.manageAccountRecordText2Templates,
                label: <FormattedMessage id="app.fields.buchtext2" tagName="span" />,
            },
            {
                key: AppRoutes.manageAccountRules,
                to: AppRoutes.manageAccountRules,
                label: <FormattedMessage id="app.titles.postingRules" tagName="span" />,
            },
        ],
        [],
    );
    return <ModuleNav selectedKeys={selectedKeys} items={items} />;
};
